/* Tha Layover — checkout is blocked until the "all sales are final" box is ticked; the agreement is stored on the cart (→ order). */
(function () {
  'use strict';
  function boxFor(el) { return el.closest('[data-tl-agree]'); }
  function save(box, agreed) {
    var attrs = {};
    attrs[box.dataset.key] = agreed ? box.dataset.value + ' (' + new Date().toISOString() + ')' : '';
    return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: attrs }) }).catch(function () {});
  }
  function block(box) {
    var err = box.querySelector('[data-tl-agree-error]'), input = box.querySelector('[data-tl-agree-input]');
    if (err) err.hidden = false;
    box.classList.add('is-invalid');
    input.focus();
  }
  document.addEventListener('change', function (e) {
    if (!e.target.matches('[data-tl-agree-input]')) return;
    var box = boxFor(e.target);
    box.classList.remove('is-invalid');
    var err = box.querySelector('[data-tl-agree-error]');
    if (err) err.hidden = true;
    document.querySelectorAll('[data-tl-agree-input]').forEach(function (i) { i.checked = e.target.checked; });
    save(box, e.target.checked);
  });
  /* cart drawer: checkout is a link */
  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-cd-checkout]');
    if (!link) return;
    var box = link.parentElement.querySelector('[data-tl-agree]');
    if (!box) return;
    e.preventDefault();
    var input = box.querySelector('[data-tl-agree-input]');
    if (!input.checked) { block(box); return; }
    save(box, true).then(function () { window.location.href = link.getAttribute('href'); });
  }, true);
  /* cart page: checkout is a submit button */
  document.addEventListener('submit', function (e) {
    var sub = e.submitter;
    if (!sub || sub.name !== 'checkout') return;
    var box = e.target.querySelector('[data-tl-agree]');
    if (box && !box.querySelector('[data-tl-agree-input]').checked) { e.preventDefault(); block(box); }
  }, true);
})();
